import {useCallback, useContext, useEffect, useState} from 'react';
import {TextFormatAlignmentBase} from '~/common/fabric/CreateDesign/components/CardEditor/actions/TextFormat/components/Alignment/TextFormatAlignmentBase/TextFormatAlignmentBase';
import {FabricContext} from '~/common/fabric/context/FabricContext';
import {LeftAlignIcon} from '~library/svg/LeftAlignIcon';
import {MiddleAlignIcon} from '~library/svg/MiddleAlignIcon';
import {RightAlignIcon} from '~library/svg/RightAlignIcon';

export const Alignment = ({className}) => {
  const {canvas} = useContext(FabricContext);
  const [selectedAlignment, setAlignment] = useState();

  useEffect(() => {
    setAlignment(canvas?.getActiveObjects()?.[0]?.textAlign);
    canvas?.on('object:reset', () => setAlignment(canvas?.getActiveObjects()?.[0]?.textAlign));
  }, [canvas]);

  const changeAlignment = useCallback(
    (align) => {
      const activeObjects = canvas?.getActiveObjects();
      activeObjects?.forEach((obj) => {
        setAlignment(align);
        obj.set('textAlign', align);
        canvas.requestRenderAll();
        canvas.fire('object:modified');
      });
    },
    [canvas]
  );

  const leftAlignment = useCallback(() => changeAlignment('left'), [changeAlignment]);
  const middleAlignment = useCallback(() => changeAlignment('center'), [changeAlignment]);
  const rightAlignment = useCallback(() => changeAlignment('right'), [changeAlignment]);

  return (
    <div className={className}>
      <TextFormatAlignmentBase
        icon={LeftAlignIcon}
        onClick={leftAlignment}
        active={selectedAlignment === 'left'}
        dataQaId="step1-textformat-leftalign"
      />
      <TextFormatAlignmentBase
        icon={MiddleAlignIcon}
        onClick={middleAlignment}
        active={selectedAlignment === 'center'}
        dataQaId="step1-textformat-centeralign"
      />
      <TextFormatAlignmentBase
        icon={RightAlignIcon}
        onClick={rightAlignment}
        active={selectedAlignment === 'right'}
        dataQaId="step1-textformat-rightalign"
      />
    </div>
  );
};
